import type { Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { TenorConfig } from './types';

export type TenorAction = SessionConfigureAction;

const initialState: TenorConfig = {
  key: '',
  searchPath: '',
  trendingPath: '',
};

const reducer: Reducer<TenorConfig, TenorAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.tenor;
    default:
      return state;
  }
};

export default reducer;
